import styled from "styled-components";
import { cores } from "../../globalStyle";

export const TagsContainer = styled.div`
    background-color: ${cores.rosaEscuro};
    color: ${cores.rosaClaro};
    padding: 6px 4px;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
`